var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60352 0.245972C2.60713 0.245972 0.166016 2.68709 0.166016 5.68347C0.166016 8.67986 2.60713 11.121 5.60352 11.121C6.89965 11.121 8.09116 10.6631 9.02686 9.90222L12.7058 13.5812C12.7576 13.6352 12.8197 13.6783 12.8884 13.708C12.9571 13.7376 13.031 13.7533 13.1059 13.7541C13.1807 13.7548 13.255 13.7407 13.3242 13.7124C13.3935 13.6841 13.4565 13.6423 13.5094 13.5893C13.5623 13.5364 13.6041 13.4735 13.6324 13.4042C13.6607 13.3349 13.6749 13.2607 13.6741 13.1858C13.6734 13.111 13.6577 13.0371 13.628 12.9684C13.5983 12.8997 13.5552 12.8376 13.5012 12.7858L9.82227 9.10681C10.5832 8.17111 11.041 6.97961 11.041 5.68347C11.041 2.68709 8.5999 0.245972 5.60352 0.245972ZM5.60352 1.37097C7.99191 1.37097 9.91602 3.29508 9.91602 5.68347C9.91602 6.84695 9.45709 7.89812 8.71265 8.67249C8.66676 8.70621 8.62626 8.74671 8.59253 8.7926C7.81816 9.53705 6.767 9.99597 5.60352 9.99597C3.21512 9.99597 1.29102 8.07186 1.29102 5.68347C1.29102 3.29508 3.21512 1.37097 5.60352 1.37097Z",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.65a2b326cf2ddeceb8093a5769fb1a72.svg";
export { ForwardRef as ReactComponent };